import "./Viewers.scss"

import React, { useCallback, useState } from "react"

import { StudioPermissions } from "@shared/apis/studioPermissions"
import {
  Account,
  Schedule,
  useAccount,
  useSchedule,
  Viewer,
} from "@shared/contexts"

import classNames from "classnames"

import { useUserActionStore } from "../../../@shared/stores/streamerStore"
import UserAction from "./UserAction"
import Users from "./Users"

// 시청자 목록/숏폼 탭 콘텐츠가 공유하는 높이 (padding 포함, border-box 기준)
export const VIEWERS_HEIGHT = 190

interface Props {
  isActive: boolean
  managers: Viewer[]
  viewers: Viewer[]
  searchKeyword: string
  studioPermissions?: StudioPermissions
}

function Viewers({
  isActive,
  managers,
  viewers,
  searchKeyword,
  studioPermissions,
}: Props) {
  const { schedule } = useSchedule()
  const { account } = useAccount()

  const {
    userAction: action,
    setUserAction: setAction,
    closeUserAction: closeAction,
    handleUserAction: handleAction,
  } = useUserActionStore()

  const users = searchKeyword
    ? managers
        .concat(viewers)
        .filter(
          (viewer: Viewer) => viewer.nickname?.indexOf(searchKeyword) > -1,
        )
    : managers.concat(viewers)

  return (
    <div
      className={classNames("viewers", {
        hidden: !isActive,
      })}
      style={{ height: VIEWERS_HEIGHT }}
    >
      <Users
        users={users}
        account={account}
        schedule={schedule}
        handleAction={handleAction}
        searchKeyword={searchKeyword}
      />
    </div>
  )
}

export default Viewers

interface ActionState {
  isActive: boolean
  props: Action
}

interface Action {
  viewer: Viewer
  account: Account
  schedule: Schedule | null
}
